module.exports = __webpack_public_path__ + "img/fiberconnect-logo.0f35c153.png";